import { render, staticRenderFns } from "./HomeTopWriters.vue?vue&type=template&id=8c3455d8&"
import script from "./HomeTopWriters.vue?vue&type=script&lang=js&"
export * from "./HomeTopWriters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports